import React from 'react';
import PropTypes from 'prop-types';

import FlagView from '../Flag/FlagView';

// Import assets
import './smHalfTile.scss';
import '../../../../assets/icons/Icon_Twitter.svg';
import '../../../../assets/icons/Icon_Facebook.svg';

const SMHalfTileView = (props) => {
  let icon = null;

  if (props.type === 'facebook') {
    icon = (<use xlinkHref="#Icon_Facebook" />);
  } else if (props.type === 'twitter') {
    icon = (<use xlinkHref="#Icon_Twitter" />);
  }

  return (
    <div className="m-tile__inner m-tile--sm">
      <FlagView flag={props.flag} flagColor={props.flagColor} flagOrientation={props.flagOrientation} />
      <div className="m-tile__content">
        <span className="m-tile__sm-text" dangerouslySetInnerHTML={{ __html: props.textComponent }} />
        <a className="m-tile__sm-icon" href={props.url} target={'_blank'} rel="noopener">
          <svg preserveAspectRatio="xMidYMid meet" x="0px" y="0px" viewBox="0 0 42 42" enableBackground="new 0 0 42 42" xmlSpace="preserve">
            {icon}
          </svg>
        </a>
      </div>
    </div>
  );
};

SMHalfTileView.propTypes = {
  url: PropTypes.string,
  type: PropTypes.string,
  textComponent: PropTypes.node,
  flag: PropTypes.string,
  flagColor: PropTypes.string,
  flagOrientation: PropTypes.string,
};

SMHalfTileView.defaultProps = {
  url: '/',
  type: '',
  textComponent: null,
  flag: '',
  flagColor: 'black',
  flagOrientation: 'left',
};

export default SMHalfTileView;



// WEBPACK FOOTER //
// ./frontend/js/Components/Tiles/SMHalfTile/SMHalfTileView.jsx